<template>
    <layout-authentication-container>
        <div class="flex py-12 px-6 w-full gap-8 max-w-xl items-center justify-between flex-col h-full rounded-xl">
            <div class="flex flex-col items-center justify-center w-full">
                <img src="@/assets/img/logo.png" @click="$router.push('/')" class="cursor-pointer h-[3.5rem]" alt="">
            </div>
            
            <div class="flex flex-col gap-8 mt-10 md:mt-6 items-start w-full justify-center">
                <div class="flex flex-col gap-1 md:gap-2 w-full">
                    <span class="text-2xl text-gray-700 tracking-wide font-medium">Create an account</span>
                    <span class="text-xs md:text-sm tracking-wide text-secondary">Create account by completing
                        the data below</span>
                </div>
                <div class="flex flex-col gap-3 w-full">
                    <div class="w-full flex-col justify-start items-start">
                        <span class="text-sm text-secondary tracking-wide">Email <span class="text-red-500">*</span> </span>
                        <a-input v-model:value="form.email" size="large" bordered class="w-full mt-2" />
                        <span v-if="errors.email" class="text-red-500 text-xs tracking-wide mt-2">{{ errors.email }}</span>
                    </div>
                    <div class="grid md:grid-cols-1 w-full gap-6">
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Full name <span
                                    class="text-red-500">*</span></span>
                            <a-input v-model:value="form.name" :maxlength="45" size="large" bordered class="w-full mt-2" />
                            <span v-if="errors.name" class="text-red-500 text-xs tracking-wide mt-2">{{ errors.name
                            }}</span>
                        </div>
                    </div>
                    
                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Company Name <span
                                    class="text-red-500">*</span></span>
                            <a-input v-model:value="form.company_name" size="large" bordered class="w-full mt-2" />
                            <span v-if="errors.company_name" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.company_name }}</span>
                        </div>

                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Position <span
                                class="text-red-500">*</span></span>
                            <a-input size="large" v-model:value="form.position" bordered class="w-full mt-2" placeholder="e.g CEO, CMO, CTO or Chairman" />
                            <span v-if="errors.position" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.position }}</span>
                        </div>
                    </div>
                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Company Sector <span
                                class="text-red-500">*</span></span>
                            <a-select size="large" v-model:value="form.company_sector" placeholder="- Select Company Sector -" class="w-full mt-2">
                                <a-select-option value="Sustainable Agriculture/Raw Materials">Sustainable Agriculture/Raw Materials</a-select-option>
                                <a-select-option value="Fisheries & Aquaculture">Fisheries & Aquaculture</a-select-option>
                                <a-select-option value="Circular Economy & Climate Resilience">Circular Economy & Climate Resilience</a-select-option>
                                <a-select-option value="Architecture & Interior Design">Architecture & Interior Design</a-select-option>
                                <a-select-option value="Banking, Financial Services & Insurance">Banking, Financial Services & Insurance</a-select-option>
                                <a-select-option value="Beauty & Skin Care">Beauty & Skin Care</a-select-option>
                                <a-select-option value="Creative Arts, Crafts, Fashion & Culture">Creative Arts, Crafts, Fashion & Culture</a-select-option>
                                <a-select-option value="Education">Education</a-select-option>
                                <a-select-option value="Employment">Employment</a-select-option>
                                <a-select-option value="Environment & Sustainable Energy">Environment & Sustainable Energy</a-select-option>
                                <a-select-option value="Food & Beverage (F&B)">Food & Beverage (F&B)</a-select-option>
                                <a-select-option value="Retail & E-commerce">Retail & E-commerce</a-select-option>
                                <a-select-option value="Health & Medicine">Health & Medicine</a-select-option>
                                <a-select-option value="Logistics & Transportation">Logistics & Transportation</a-select-option>
                                <a-select-option value="Manufacturing & Infrastructure">Manufacturing & Infrastructure</a-select-option>
                                <a-select-option value="Telecommunications & Digital">Telecommunications & Digital</a-select-option>
                                <a-select-option value="Tourism">Tourism</a-select-option>
                                <a-select-option value="Other">Other</a-select-option>
                            </a-select>
                            <span v-if="errors.company_sector" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.company_sector }}</span>
                        </div>

                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Website or Social Media</span>
                            <a-input size="large" v-model:value="form.professional_link" placeholder="https://yourwebsite.com" class="w-full mt-2" />
                            <span v-if="errors.professional_link" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.professional_link }}</span>
                        </div>
                    </div>
                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Year of Establishment <span
                                class="text-red-500">*</span></span>
                            
                            <a-select size="large" class="mt-2 w-full" :name="'year'" :placeholder="'-- Choose Year --'" required v-model:value="form.year_estbl">
                                <a-select-option v-for="option in yearOptions" :key="option" :value="option">{{ option }}</a-select-option>
                            </a-select>
                            <span v-if="errors.year_estbl" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.year_estbl }}</span>
                        </div>

                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Province <span
                                class="text-red-500">*</span></span>
                            
                            <a-select size="large" class="mt-2 w-full" :name="'province'" :placeholder="'-- Choose Province --'" required v-model:value="form.province_id">
                                <a-select-option v-for="option in provinceOptions" :key="option.id" :value="option.id">{{ option.name }}</a-select-option>
                            </a-select>
                            <span v-if="errors.province_id" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.province_id }}</span>
                        </div>

                        <!-- <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Description of Your Business <span
                                class="text-red-500">*</span></span>
                            <a-textarea show-count :maxlength="150" v-model:value="form.description" class="resize-none w-full mt-2"
                                :rows="4" />
                            <span v-if="errors.description" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.description }}</span>
                        </div> -->
                    </div>

                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Gender <span
                                class="text-red-500">*</span></span>
                            <a-select size="large" v-model:value="form.gender" class="mt-2 w-full">
                                <a-select-option value="M">Male</a-select-option>
                                <a-select-option value="F">Female</a-select-option>
                                <a-select-option value="NB">Non Binary</a-select-option>
                            </a-select>
                            
                            <span v-if="errors.gender" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.gender }}</span>
                        </div>

                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Designation <span
                                class="text-red-500">*</span></span>
                            <a-select size="large" v-model:value="form.designation" placeholder="- Select -" class="mt-2 w-full">
                                <a-select-option value="Mr">Mr</a-select-option>
                                <a-select-option value="Ms">Ms</a-select-option>
                                <a-select-option value="Mrs">Mrs</a-select-option>
                                <a-select-option value="Dr">Dr</a-select-option>
                                <a-select-option value="Prof">Prof</a-select-option>
                                <a-select-option value="Others">Others </a-select-option>
                            </a-select>
                            <span v-if="errors.designation" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.designation }}</span>
                        </div>

                        <!-- <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Description of Your Business <span
                                class="text-red-500">*</span></span>
                            <a-textarea show-count :maxlength="150" v-model:value="form.description" class="resize-none w-full mt-2"
                                :rows="4" />
                            <span v-if="errors.description" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.description }}</span>
                        </div> -->
                    </div>

                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="w-full col-span-2 flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Description of Your Business <span
                                class="text-red-500">*</span></span>
                            <a-textarea show-count :maxlength="1000" v-model:value="form.description" class="resize-none w-full mt-2"
                                :rows="4" />
                            <span v-if="errors.description" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.description }}</span>
                        </div>
                    </div>
                    

                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="gap-2 col-span-2">
                            <span class="text-sm text-secondary tracking-wide">How did you first hear about this platform/program? <span class="text-red-500">*</span></span>
                            
                            <div>
                                <span v-if="errors.referral_source" class="text-red-500 text-xs tracking-wide mt-2">{{
                                    errors.referral_source }}</span>
                            </div>

                            <!-- <a-checkbox-group v-model:value="form.referral_source" class="grid grid-cols-1 gap-3 w-full mt-2 items-center">
                                <a-checkbox v-for="program in programs" :key="program.id" :value="program.title"  class="break-words whitespace-normal">{{ program.title }}</a-checkbox>
                            </a-checkbox-group> -->
                            <a-radio-group v-model:value="form.referral_source" class="flex flex-col gap-3 mt-2 w-full">
                                <a-radio :value="'Social media (Instagram, LinkedIn, Facebook, YouTube, etc.)'">Social media (Instagram, LinkedIn, Facebook, YouTube, etc.)</a-radio>
                                <a-radio :value="'Instellar website'">Instellar website</a-radio>
                                <a-radio :value="'Instellar email newsletter'">Instellar email newsletter</a-radio>
                                <a-radio :value="'Friend/colleague'">Friend/colleague</a-radio>
                                <a-radio :value="'Other (write your own)'">
                                    Other (write your own)
                                </a-radio>
                            </a-radio-group>

                            <a-input v-if="form.referral_source === 'Other (write your own)'" v-model:value="form.other_hear" class="w-6/12 ms-6 mt-2" />
                        </div>
                    </div>

                    <div class="grid md:grid-cols-2 w-full gap-6" v-if="programs.length > 0">
                        <div class="gap-2 col-span-2">
                            <span class="text-sm text-secondary tracking-wide">Which program would you like to join? <span class="text-red-500">*</span></span>
                            
                            <div>
                                <span v-if="errors.program_interest" class="text-red-500 text-xs tracking-wide mt-2">{{
                                    errors.program_interest }}</span>
                            </div>

                            <a-checkbox-group v-model:value="form.program_interest" class="grid grid-cols-1 gap-3 w-full mt-2 items-center">
                                <a-checkbox v-for="program in programs" :key="program.id" :value="program.title"  class="break-words whitespace-normal">{{ program.title }}</a-checkbox>
                            </a-checkbox-group>
                        </div>
                    </div>

                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="gap-2 col-span-2">
                            <span class="text-sm text-secondary tracking-wide">Industry <span class="text-xs">(max. 3)</span><span class="text-red-500">*</span></span>
                            
                            <div>
                                <span v-if="errors.industry" class="text-red-500 text-xs tracking-wide mt-2">{{
                                    errors.industry }}</span>
                            </div>
                            <a-checkbox-group v-model:value="form.industry" class="grid grid-cols-1 xl:grid-cols-2 gap-3 w-full mt-2 items-center">
                                <a-checkbox v-for="industry in industries" :key="industry" :value="industry"  class="break-words whitespace-normal" :disabled="(form.industry).length > 2 && !(form.industry).includes(industry)">{{ industry }}</a-checkbox>
                            </a-checkbox-group>
                        </div>
                    </div>

                    <div class="grid md:grid-cols-2 w-full gap-6 mt-2">
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Beneficiaries Type <span
                                class="text-red-500">*</span></span>
                            
                            <a-select size="large" class="mt-2 w-full" :name="'beneficaries_type'" :placeholder="'-- Choose Beneficiaries --'" required v-model:value="form.beneficiaries_type">
                                <a-select-option v-for="option in beneficiaryOptions" :key="option" :value="option">{{ option }}</a-select-option>
                            </a-select>
                            <span v-if="errors.beneficiaries_type" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.beneficiaries_type }}</span>
                        </div>

                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Impact Measurement</span>
                            <a-textarea show-count :maxlength="150" v-model:value="form.impact_measurement" class="resize-none w-full mt-2"
                                :rows="4" />
                            <span v-if="errors.impact_measurement" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.impact_measurement }}</span>
                        </div>
                    </div>

                    <div class="grid md:grid-cols-2 w-full gap-3 my-3">
                        <span class="text-sm text-secondary tracking-wide">Funding</span>

                        <div
                            v-for="(funding, index) in form.funding_history"
                            :key="funding.id"
                            class="col-span-2 grid grid-cols-10 items-center justify-center gap-3"
                        >
                            <hr class="col-span-10 mb-2" v-if="index > 0">
                            
                            <div class="col-span-9 grid grid-cols-9 items-center justify-center gap-3">
                                <a-select size="large" class="col-span-3 md:col-span-2 md:order-1" :name="'Year'" :placeholder="'-- Year --'" required v-model:value="funding.year">
                                    <a-select-option v-for="option in yearOptions" :key="option" :value="option">{{ option }}</a-select-option>
                                </a-select>
     
                                <a-input-number
                                    size="large" bordered class="w-full col-span-6 md:col-span-3 md:order-3"
                                    placeholder="Amount"
                                    v-model:value="funding.amount"
                                    :formatter="value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                    :parser="value => value.replace(/Rp\s?|(,*)/g, '')"
                                />
     
                                <a-input v-model:value="funding.investor" size="large" placeholder="Investor Name" class="col-span-9 md:col-span-4 md:order-2" />
                            </div>
                            
                            <IconMinus @click="removeFunding(funding)" class="cursor-pointer col-span-1 flex items-center justify-center self-center" />

                            <div class="col-span-10 flex flex-col">
                                <span v-if="errors?.funding_history[index]" class="text-red-500 text-xs tracking-wide mt-2">{{ errors?.funding_history[index] }}</span>
                            </div>
                        </div>

                        <a-button type="dashed" block @click="addFunding" class="flex flex-row items-center justify-center gap-1 col-span-2">
                            <IconPlus />
                            Add funding
                        </a-button>
                    </div>

                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Username <span
                                    class="text-red-500">*</span></span>
                            <a-input prefix="@" v-model:value="form.username" size="large" bordered class="w-full mt-2" />
                            <span v-if="errors.username" class="text-red-500 text-xs tracking-wide mt-2">{{ errors.username
                            }}</span>
                        </div>
                        <div class="w-full flex flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Phone Number <span class="text-red-500">*</span></span>
                            <div class="mt-2 w-full flex flex-row gap-2 items-center">
                                <a-auto-complete 
                                    size="large" 
                                    :default-open="false" 
                                    :value="selectedCountry.flag" 
                                    @search="searchCountry" 
                                    @select="selectCountry" 
                                    :dropdown-match-select-width="300" 
                                    class="w-16" 
                                    :options="countryFilter">
                                    <template #option="item">
                                        {{ item.flag }} {{ item.label }}
                                    </template>
                                    <a-input class="w-16" size="large">
                                        <!-- <template #prefix>
                                            <span>{{ selectedCountry.flag }}</span>
                                        </template> -->
                                        <template #suffix>
                                            <IconChevronDown :size="10" />
                                        </template>
                                        <input
                                            :value="form.phone"
                                            @input="formatPhoneNumber"
                                            placeholder="Enter phone number"
                                        />
                                    </a-input>
                                </a-auto-complete>

                                <a-input 
                                    placeholder="850-000-000-00" 
                                    v-model:value="form.phone" 
                                    size="large" 
                                    bordered 
                                    class="w-full"
                                    @input="formatPhoneNumber"
                                    :prefix="selectedCountry.value"
                                    >
                                </a-input>
                            </div>
                            <span v-if="errors.phone" class="text-red-500 text-xs tracking-wide mt-2">{{ errors.phone }}</span>
                        </div>
                    </div>
                    <div class="grid md:grid-cols-2 w-full gap-6">
                        <div class="w-full flex flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Password <span
                                    class="text-red-500">*</span></span>
                            <a-input-password v-model:value="form.password" size="large" bordered class="w-full mt-2" />
                            <span v-if="errors.password" class="text-red-500 text-xs tracking-wide mt-2">{{ errors.password
                            }}</span>
                        </div>
                        <div class="w-full flex-col justify-start items-start">
                            <span class="text-sm text-secondary tracking-wide">Confirm Password <span
                                    class="text-red-500">*</span></span>
                            <a-input-password v-model:value="form.password_confirmation" size="large" bordered
                                class="w-full mt-2" />
                            <span v-if="errors.password_confirmation" class="text-red-500 text-xs tracking-wide mt-2">{{
                                errors.password_confirmation }}</span>
                        </div>
                    </div>
                </div>
                <div class="w-full flex-col justify-start items-start">
                    <a-checkbox v-model:checked="agreement">
                        <span class="text-sm tracking-wide">I have read and agree to <a href="#" class="text-primary" @click="dialogTC = true">Terms and
                                Conditions</a></span>
                    </a-checkbox>
                    <span v-if="errors.agreement" class="text-red-500 text-xs leading-relaxed tracking-wide">{{
                        errors.agreement }}</span>
                </div>
                <a-button :loading="isLoading" @click="onClickSignUp" class="w-full" type="primary" size="large">Register
                    Now</a-button>
                <div class="w-full justify-center gap-1 pb-8 items-center flex">
                    <span class="text-sm font-normal tracking-wide text-secondary">Already have an account?</span>
                    <span @click="$router.replace({ path: '/SignIn' })" class="text-primary cursor-pointer text-sm font-normal">Sign
                        In</span>
                </div>
            </div>
        </div>

        <a-modal v-model:open="dialogTC" :width="800" okText="Ok" title="Terms and Conditions"
            @ok="dialogTC = false">
            <div class="py-5 w-full flex flex-col gap-6">
                <div class="gap-3 flex flex-col w-full">
                    <h4 class="text-lg font-semibold">1. Introduction</h4>
                    <p class="text-sm text-gray-700">
                    Welcome to our website. By accessing this website, you agree to be bound by these terms and conditions.
                    </p>
                    <h4 class="text-lg font-semibold mt-4">2. Intellectual Property Rights</h4>
                    <p class="text-sm text-gray-700">
                    Other than the content you own, under these Terms, we own all intellectual property rights and materials contained in this website.
                    </p>
                    <h4 class="text-lg font-semibold mt-4">3. Restrictions</h4>
                    <p class="text-sm text-gray-700">
                    You are specifically restricted from publishing any website material in any other media, selling or sublicensing any website material, and using this website in any way that may cause harm.
                    </p>
                    <h4 class="text-lg font-semibold mt-4">4. Limitation of Liability</h4>
                    <p class="text-sm text-gray-700">
                    In no event shall the website be held liable for anything arising out of or in any way connected with your use of this website.
                    </p>
                    <h4 class="text-lg font-semibold mt-4">5. Amendments</h4>
                    <p class="text-sm text-gray-700">
                    We reserve the right to revise these terms at any time as we see fit, and by using this website, you are expected to review these terms regularly.
                    </p>
                </div>
            </div>
            <template #footer>
                <div class="w-full flex items-center justify-end">
                    <a-button type="text" class="text-primary" @click="dialogTC = false">I Understand</a-button>
                </div>
            </template>
        </a-modal>
    </layout-authentication-container>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from "vue";
import { message } from 'ant-design-vue';
import AuthApi from "../../api/auth";
import { IconChevronDown, IconMinus, IconPlus } from "@tabler/icons-vue";
import { useBreakpoint } from "@/composables/useBreakpoints";
import useAuth from "@/composables/useAuth";
import axios from "@/plugins/axios";

const { lgAndUp } = useBreakpoint();
const dialogTC = ref(false);

// Country selection
const selectedCountry = ref({ flag: '🇮🇩', value: '+62', label: 'Indonesia (+62)' });
const countryCode = ref('+62');
const programs = ref([])

const industries = [
    "Agriculture", 
    "Arts, Culture & Entertainment", 
    "Education", 
    "Energy & Power", 
    "Environment & Waste Management", 
    "Food & Beverage", 
    "Financial Services", 
    "General Consultancy", 
    "Healthcare & Social Services", 
    "Housing & Accommodation", 
    "Information & Communications", 
    "Manufacturing", 
    "Materials & Packaging", 
    "Retail & Consumer Goods", 
    "Supply Chain, Logistics & Trading", 
    "Technology", 
    "Tourism Services", 
    "Transportation & Automotives",
    "Water Supply", 
    "Others"
]

const countryList = [
    { flag: '🇦🇺', value: '+61', label: 'Australia (+61)' },
    { flag: '🇺🇸', value: '+1', label: 'United States (+1)' },
    { flag: '🇬🇧', value: '+44', label: 'United Kingdom (+44)' },
    { flag: '🇮🇳', value: '+91', label: 'India (+91)' },
    { flag: '🇨🇳', value: '+86', label: 'China (+86)' },
    { flag: '🇯🇵', value: '+81', label: 'Japan (+81)' },
    { flag: '🇩🇪', value: '+49', label: 'Germany (+49)' },
    { flag: '🇫🇷', value: '+33', label: 'France (+33)' },
    { flag: '🇮🇹', value: '+39', label: 'Italy (+39)' },
    { flag: '🇧🇷', value: '+55', label: 'Brazil (+55)' },
    { flag: '🇷🇺', value: '+7', label: 'Russia (+7)' },
    { flag: '🇪🇸', value: '+34', label: 'Spain (+34)' },
    { flag: '🇨🇦', value: '+1', label: 'Canada (+1)' },
    { flag: '🇧🇪', value: '+32', label: 'Belgium (+32)' },
    { flag: '🇳🇱', value: '+31', label: 'Netherlands (+31)' },
    { flag: '🇳🇿', value: '+64', label: 'New Zealand (+64)' },
    { flag: '🇿🇦', value: '+27', label: 'South Africa (+27)' },
    { flag: '🇰🇷', value: '+82', label: 'South Korea (+82)' },
    { flag: '🇸🇪', value: '+46', label: 'Sweden (+46)' },
    { flag: '🇳🇴', value: '+47', label: 'Norway (+47)' },
    { flag: '🇨🇭', value: '+41', label: 'Switzerland (+41)' },
    { flag: '🇫🇮', value: '+358', label: 'Finland (+358)' },
    { flag: '🇹🇷', value: '+90', label: 'Turkey (+90)' },
    { flag: '🇸🇬', value: '+65', label: 'Singapore (+65)' },
    { flag: '🇲🇾', value: '+60', label: 'Malaysia (+60)' },
    { flag: '🇲🇽', value: '+52', label: 'Mexico (+52)' },
    { flag: '🇨🇱', value: '+56', label: 'Chile (+56)' },
    { flag: '🇵🇭', value: '+63', label: 'Philippines (+63)' },
    { flag: '🇮🇩', value: '+62', label: 'Indonesia (+62)' },
    { flag: '🇸🇦', value: '+966', label: 'Saudi Arabia (+966)' },
    { flag: '🇦🇪', value: '+971', label: 'United Arab Emirates (+971)' },
    { flag: '🇧🇭', value: '+973', label: 'Bahrain (+973)' },
    { flag: '🇶🇦', value: '+974', label: 'Qatar (+974)' },
    { flag: '🇧🇾', value: '+375', label: 'Belarus (+375)' },
    { flag: '🇺🇦', value: '+380', label: 'Ukraine (+380)' },
    { flag: '🇭🇺', value: '+36', label: 'Hungary (+36)' },
    { flag: '🇦🇹', value: '+43', label: 'Austria (+43)' },
    { flag: '🇩🇰', value: '+45', label: 'Denmark (+45)' },
    { flag: '🇬🇷', value: '+30', label: 'Greece (+30)' },
    { flag: '🇷🇴', value: '+40', label: 'Romania (+40)' },
    { flag: '🇵🇱', value: '+48', label: 'Poland (+48)' },
    { flag: '🇵🇹', value: '+351', label: 'Portugal (+351)' },
    { flag: '🇮🇪', value: '+353', label: 'Ireland (+353)' },
    { flag: '🇮🇸', value: '+354', label: 'Iceland (+354)' },
    { flag: '🇪🇪', value: '+372', label: 'Estonia (+372)' },
    { flag: '🇲🇩', value: '+373', label: 'Moldova (+373)' },
    { flag: '🇬🇪', value: '+995', label: 'Georgia (+995)' },
    { flag: '🇺🇿', value: '+998', label: 'Uzbekistan (+998)' },
    { flag: '🇲🇲', value: '+95', label: 'Myanmar (+95)' },
    { flag: '🇻🇳', value: '+84', label: 'Vietnam (+84)' },
    { flag: '🇹🇭', value: '+66', label: 'Thailand (+66)' },
    { flag: '🇮🇷', value: '+98', label: 'Iran (+98)' },
    { flag: '🇱🇰', value: '+94', label: 'Sri Lanka (+94)' },
    { flag: '🇵🇰', value: '+92', label: 'Pakistan (+92)' },
    { flag: '🇬🇭', value: '+233', label: 'Ghana (+233)' },
    { flag: '🇰🇪', value: '+254', label: 'Kenya (+254)' },
    { flag: '🇺🇬', value: '+256', label: 'Uganda (+256)' },
    { flag: '🇳🇬', value: '+234', label: 'Nigeria (+234)' },
    { flag: '🇮🇪', value: '+353', label: 'Ireland (+353)' },
];

const yearOptions = Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i);
const beneficiaryOptions = [
    'Communities',
    'Cooperatives',
    'Social Enterprises',
    'Farmer Groups',
    'Women’s Groups',
    'Youth Organizations',
    'Others'
]
const provinceOptions = ref([]);

const countryFilter = ref(countryList);
const authApi = new AuthApi();
const isLoading = ref(false);
const form = ref({
    company_name: '',
    company_sector: '',
    position: '',
    professional_link: '',
    gender: '',
    designation: '',
    description: '',
    industry: [],
    year_estbl: '',
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    country_code: '',
    phone: '',
    username: '',
    agreement: '',
    province_id: '',
    beneficiaries_type: '',
    impact_measurement: '',
    program_interest: '',
    referral_source: '',
    other_hear: '',
    funding_history: [
        // {
        //     year: yearOptions[0],
        //     investor: '',
        //     amount: 0,
        //     id: Date.now(),
        // }
    ],
});
const agreement = ref(false);
const errors = ref({
    company_name: '',
    company_sector: '',
    position: '',
    professional_link: '',
    designation: '',
    gender: '',
    description: '',
    industry: '',
    year_estbl: '',
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    phone: '',
    username: '',
    agreement: '',
    province_id: '',
    program_interest: '',
    referral_source: '',
    other_hear: '',
    beneficiaries_type: '',
    impact_measurement: '',
    funding_history: [
        // {
        //     year: '',
        //     investor: '',
        //     amount: '',
        //     id: Date.now(),
        // }
    ],
});

// Watchers for error handling
watch(form.value, (newValue) => {
    if (newValue.email) errors.value.email = '';
    if (newValue.name) errors.value.name = '';
    if (newValue.company_name) errors.value.company_name = '';
    if (newValue.company_sector) errors.value.company_sector = '';
    if (newValue.position) errors.value.position = '';
    if (newValue.professional_link) errors.value.professional_link = '';
    if (newValue.gender) errors.value.gender = '';
    if (newValue.designation) errors.value.designation = '';
    if (newValue.description) errors.value.description = '';
    if (newValue.industry) errors.value.industry = '';
    if (newValue.year_estbl) errors.value.year_estbl = '';
    if (newValue.agreement) errors.value.agreement = '';
    if (newValue.province_id) errors.value.province_id = '';
    if (newValue.username) errors.value.username = '';
    if (newValue.phone) errors.value.phone = '';
    if (newValue.password) errors.value.password = '';
    if (newValue.password_confirmation) errors.value.password_confirmation = '';
    if (newValue.program_interest) errors.value.program_interest = '';
    if (newValue.referral_source) errors.value.referral_source = '';
    if (newValue.beneficiaries_type) errors.value.beneficiaries_type = '';
    if (newValue.impact_measurement) errors.value.impact_measurement = '';

    newValue.funding_history.forEach((item, index) => {
        if (newValue.funding_history[index]) errors.value.funding_history[index] = '';
    });
});

watch(agreement, (newValue) => {
    if (newValue) errors.value.agreement = '';
});

const fetchPrograms = async () => {
    try {
        const response = await axios.get('/open-register-programs');
        programs.value = response?.data

    } catch (error) {
        console.error('Error fetching programs:', error)
    }
}

const removeFunding = (item) => {
    const index = form.value.funding_history.indexOf(item);
    if (index !== -1) {
        form.value.funding_history.splice(index, 1);
        errors.value.funding_history.splice(index, 1);
    }
};
const addFunding = () => {
    form.value.funding_history.push({
        year: yearOptions[0],
        investor: '',
        amount: 0,
        id: Date.now(),
    });
    
    errors.value.funding_history.push('');
};

// Search country based on input
const searchCountry = (str) => {
    const lowerCaseSearchTerm = str.toLowerCase();
    countryFilter.value = countryList.filter(country =>
        country.label.toLowerCase().includes(lowerCaseSearchTerm)
    );
};

// Select a country
const selectCountry = (item) => {
    const country = countryList.find(country => country.value === item);
    if(country) selectedCountry.value = country;
};


// Format phone number
const formatPhoneNumber = (e) => {
    let phone = e.target.value;

    if (phone.startsWith('0')) {
        phone = phone.slice(1);
    }
    form.value.phone = phone.replace(/\D/g, '');
};

// Validate form data
// const validateForm = () => {
//     errors.value = {
//         company_name: '',
//         company_sector: '',
//         position: '',
//         professional_link: '',
//         designation: '',
//         industry: '',
//         year_estbl: '',
//         name: '',
//         email: '',
//         password: '',
//         password_confirmation: '',
//         phone: '',
//         username: '',
//         agreement: '',
//         province_id: ''
//     };

//     let isValid = true;

//     if (!form.value.company_sector) {
//         errors.value.company_sector = 'Company Sector is required.';
//         isValid = false;
//     }
//     if (!form.value.position) {
//         errors.value.position = 'Position is required.';
//         isValid = false;
//     }
//     if (!form.value.professional_link) {
//         errors.value.professional_link = 'Webiste or Social Media is required.';
//         isValid = false;
//     }
//     if (!form.value.designation) {
//         errors.value.designation = 'Designation is required.';
//         isValid = false;
//     }
//     if (form.value.industry.length == 0) {
//         errors.value.industry = 'Industry is required.';
//         isValid = false;
//     }
//     if (!form.value.description) {
//         errors.value.description = 'Description is required.';
//         isValid = false;
//     }
//     if (!form.value.year_estbl) {
//         errors.value.year_estbl = 'Year of Establishment is required.';
//         isValid = false;
//     }
//     if (!form.value.province_id) {
//         errors.value.province_id = 'Province is required.';
//         isValid = false;
//     }
//     if (!form.value.email) {
//         errors.value.email = 'Email is required.';
//         isValid = false;
//     }
//     if (!form.value.name) {
//         errors.value.name = 'Full name is required.';
//         isValid = false;
//     }
//     if (!form.value.company_name) {
//         errors.value.company_name = 'Company name is required.';
//         isValid = false;
//     }
//     if (!form.value.username) {
//         errors.value.username = 'Username is required.';
//         isValid = false;
//     }
//     if (!form.value.phone) {
//         errors.value.phone = 'Phone number is required.';
//         isValid = false;
//     }
//     if (form.value.phone.startsWith('0')) {
//         errors.value.phone = 'Phone Format Invalid.';
//         isValid = false;
//     }
//     if (!form.value.password) {
//         errors.value.password = 'Password is required.';
//         isValid = false;
//     }
//     if (form.value.password !== form.value.password_confirmation) {
//         errors.value.password_confirmation = 'Passwords do not match.';
//         isValid = false;
//     }
//     if (!agreement.value) {
//         errors.value.agreement = 'You must agree to the terms and conditions.';
//         isValid = false;
//     }

//     return isValid;
// };

// Handle backend errors
const handleBackendErrors = (backendErrors) => {
    Object.keys(backendErrors).forEach(field => {
        if (errors.value[field] !== undefined) {
            errors.value[field] = backendErrors[field][0]; // Display the first error for each field
        }else if(field.startsWith('funding_history.')){
            const fieldSplit = field.split('.');
            const index = fieldSplit[1];
            // const fieldName = fieldSplit[2];

            // const manageMessage = (backendErrors[field][0]).replace(field, 'Funding ' + fieldName).replace('field', 'field (' + (parseInt(index) + 1) + ')');

            errors.value.funding_history[index] = backendErrors[field][0];
        }
    });
};

onMounted(() => {
    document.addEventListener('keypress', handleKeyPress)
    fetchProvince();
    fetchPrograms();
})


onUnmounted(() => {
  document.removeEventListener('keypress', handleKeyPress)
})


const handleKeyPress = (event) => {
  if (event.key === 'Enter') {
    onClickSignUp()
  }
}

const fetchProvince = async () => {
    try {
        const response = await axios.get('/province');

        provinceOptions.value = response.data;
    } catch (error) {
        console.error('Error fetching province:', error)
        message.error('Failed to load province data. Please try again later.');
    }
}

// Sign-up function
const onClickSignUp = async () => {
    // if (validateForm()) {
        isLoading.value = true;
        try {
            // if (!form.value.phone.startsWith(selectedCountry.value.value)){
            //     form.value.phone = `${form.value.phone}`;
            // }

            form.value.country_code = (selectedCountry.value.value).replace('+', '');

            // console.log(form.value);
            const response = await authApi.register(form.value);

            useAuth().set(null, response.data.access_token, false);
            window.location.href = "/Verify/Email";
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errors) {
                handleBackendErrors(error.response.data.errors);
            } 
            // else {
            // console.error('Error during sign-up:', error);
                message.error(error?.response?.data?.message);
            // }
        } finally {
            isLoading.value = false;
        }
    // }
};
</script>

